/**
 * Safe localStorage utilities
 * Handles SSR and storage errors gracefully
 */

export const storage = {
  /**
   * Read value from localStorage
   * @param {string} key - Storage key
   * @returns {string|null} Stored value or null
   */
  read: (key) => {
    if (typeof window === "undefined") return null;
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  /**
   * Write value to localStorage
   * @param {string} key - Storage key
   * @param {any} value - Value to store (will be converted to string)
   */
  write: (key, value) => {
    if (typeof window === "undefined") return;
    try {
      if (value === null || value === undefined) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, String(value));
      }
    } catch {
      // Ignore storage errors
    }
  },

  /**
   * Remove value from localStorage
   * @param {string} key - Storage key
   */
  remove: (key) => {
    if (typeof window === "undefined") return;
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore storage errors
    }
  },

  /**
   * Read and parse JSON from localStorage
   * @param {string} key - Storage key
   * @returns {any|null} Parsed value or null
   */
  readJSON: (key) => {
    const value = storage.read(key);
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  },

  /**
   * Write JSON to localStorage
   * @param {string} key - Storage key
   * @param {any} value - Value to stringify and store
   */
  writeJSON: (key, value) => {
    if (value === null || value === undefined) {
      storage.remove(key);
      return;
    }
    try {
      storage.write(key, JSON.stringify(value));
    } catch {
      // Ignore storage errors
    }
  },
};
